import {
  USER_LOGIN,
  USER_LOGOUT,
  LOGIN_ERROR,
  TOKEN_GENRATE,
  USER_FORGOT,
  USER_OTPVERIFY,
  REMOVE_FORGOT_DATA,
  ACK_FORGOT_OTP_SEND,
  USER_UPDATEPASSWORD,
  USER_CHANGEPASSWORD,
  CLEAR_MUST_CHANGE_PASSWORD,
  FIREBASE_UPDATE,
  GET_USER_PROFILE,
} from "../types";
import authService from "../service/authService";
import strings from "translate/language";
import {
  errorToast,
  unAuthorizedError,
  successToast,
} from "../../utils/httpClient";
import {
  resetGlobalLoader,
  showGlobalLoader,
} from "../../utils/globalLoader";

export const jwtTokenGenrate = () => async (dispatch) => {
  try {
    const res = await authService.tokenGenrate();
    if (res.data.status === 200) {
      dispatch({
        type: TOKEN_GENRATE,
        payload: res.data,
      });
    }
  } catch (e) {
    // Public token fetch must not sign the user out or reload the page.
  }
};
export const userLogin = (item) => async (dispatch) => {
  try {
    const res = await authService.login(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_LOGIN,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    if (response.data.status === 401 || response.data.status === 400) {
      dispatch(jwtTokenGenrate());
      unAuthorizedError(response.data);
    }
  }
};
export const firebaseIdUpdate = (item) => async (dispatch) => {
  try {
    const res = await authService.firebaseIdUpdate(item);
    if (res.data.status === 200) {
      dispatch({
        type: FIREBASE_UPDATE,
        payload: item.data,
      });
    } else {
      // errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    if (response.data.status === 401 || response.data.status === 400) {
      dispatch(jwtTokenGenrate());
      unAuthorizedError(response.data);
    }
  }
};

export const userLogout = () => async (dispatch) => {
  showGlobalLoader("Signing out", "Please wait…");
  try {
    await localStorage.setItem("persistantState", null);
    await localStorage.removeItem("persistantState");
    await localStorage.clear();
    dispatch({
      type: GET_USER_PROFILE,
      payload: null,
    });
    dispatch({
      type: USER_LOGOUT,
      payload: null,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    dispatch({
      type: LOGIN_ERROR,
      payload: response.data,
    });
  } finally {
    resetGlobalLoader();
  }
};
export const forgotPassword = (item) => async (dispatch) => {
  try {
    const res = await authService.forgotPassword(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_FORGOT,
        payload: res.data,
        data: item,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response?.data?.message);
  }
};
export const forgotRemoveData = (item) => async (dispatch) => {
  try {
    // if (res.data.status === 200) {
    dispatch({
      type: REMOVE_FORGOT_DATA,
      payload: null,
    });
    // } else {
    // errorToast(res.data.message)
    // }
  } catch (e) {
    const { response = strings.initialError } = e;
    // dispatch({
    //     type: LOGIN_ERROR,
    //     payload: response.data,
    // })
    unAuthorizedError(response.data);
  }
};
export const ackForgotOtpSend = () => (dispatch) => {
  dispatch({ type: ACK_FORGOT_OTP_SEND });
};
export const otpVerify = (item) => async (dispatch) => {
  try {
    const res = await authService.otpVerify(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_OTPVERIFY,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;

    errorToast(response?.data?.message);
  }
};
export const resendOtp = (item) => async (dispatch) => {
  try {
    const res = await authService.resendOtp(item);
    if (res.data.status === 200) {
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response?.data?.message);
  }
};
export const updatePassword = (item) => async (dispatch) => {
  try {
    const res = await authService.updatePassword(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_UPDATEPASSWORD,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const ChangePassword = (item) => async (dispatch) => {
  try {
    const res = await authService.ChangePassword(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_CHANGEPASSWORD,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const clearMustChangePassword = () => (dispatch) => {
  dispatch({
    type: CLEAR_MUST_CHANGE_PASSWORD,
  });
};
export const universalRemoveAction = (type) => async (dispatch) => {
  dispatch({
    type: type,
    payload: null,
  });
};
